import {
  ApartmentOutlined,
  BookOutlined,
  DeploymentUnitOutlined,
  FileTextOutlined,
  GiftOutlined,
  GroupOutlined,
  LineChartOutlined,
  SendOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import i18n from "translations/i18n";
import urls from "urls";

const shopNavTree = [
  {
    key: "sales",
    title: i18n.t("sales"),
    breadcrumb: false,
    submenu: [
      {
        key: "shop-reports",
        path: urls.reports,
        title: i18n.t("reports"),
        icon: LineChartOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-reports-general",
            path: urls.reportsGeneral,
            title: i18n.t("general"),
            icon: "",
            submenu: [],
          },
          {
            key: "shop-reports-products",
            path: urls.reportsProducts,
            title: i18n.t("products"),
            icon: "",
            submenu: [],
          },
          {
            key: "shop-reports-sellers",
            path: urls.reportsSellers,
            title: i18n.t("sellers"),
            icon: "",
            submenu: [],
          },
        ],
      },
      {
        key: "shop-products",
        title: i18n.t("products"),
        icon: ShoppingCartOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-products-productList",
            path: urls.productList,
            title: i18n.t("products"),
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "shop-products-productEvents",
            path: urls.productEvents,
            title: i18n.t("product_events"),
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "shop-products-attributes",
            path: urls.productAttributes,
            title: i18n.t("product_attributes"),
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-categories",
        path: urls.categories,
        title: i18n.t("categories"),
        icon: GroupOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-discounts",
        title: i18n.t("discounts"),
        icon: GiftOutlined,
        breadcrumb: false,
        submenu: [
          // {
          //   key: "shop-discounts-promotions",
          //   path: urls.promotions,
          //   title: i18n.t("promotions"),
          //   icon: "",
          //   breadcrumb: true,
          //   submenu: [],
          // },
          {
            key: "shop-discounts-discountCode",
            path: urls.discountCodes,
            title: i18n.t("discount_codes"),
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-orders",
        title: i18n.t("order.orders"),
        icon: FileTextOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-orders-all",
            path: urls.ordersList,
            title: i18n.t("order.orders"),
            icon: "",
            submenu: [],
          },
          {
            key: "shop-orders-exact",
            path: urls.exactOrdersList,
            title: i18n.t("order.exact"),
            icon: "",
            submenu: [],
          },
        ],
      },
      {
        key: "shop-shipments",
        path: urls.shipmentsList,
        title: i18n.t("shipment.shipments"),
        icon: SendOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-customers",
        title: i18n.t("customers"),
        icon: SolutionOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-customers-existing",
            path: urls.customerList,
            title: i18n.t("customers_all"),
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-customers-pending",
            path: urls.customerListPending,
            title: i18n.t("customers_pending"),
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-customers-audiences",
            path: urls.audiences,
            title: i18n.t("audiences"),
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-customers-map",
            path: urls.customerMap,
            title: i18n.t("customer_map"),
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-dealers",
        title: i18n.t("dealers"),
        path: urls.dealers,
        icon: DeploymentUnitOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const purchasingNavTree = [
  {
    key: "purchasing",
    title: i18n.t("purchasing"),
    breadcrumb: false,
    submenu: [
      {
        key: "purchasing-purchase-orders",
        icon: SolutionOutlined,
        title: i18n.t("order.purchase_orders"),
        submenu: [
          {
            key: "purchasing-purchase-orders-all",
            path: urls.purchaseOrdersList,
            title: i18n.t("orders"),
            icon: "",
            submenu: [],
          },
          {
            key: "purchasing-shipments",
            path: urls.purchaseOrderShipmentsList,
            title: i18n.t("purchase_order_shipments"),
            icon: "",
            submenu: [],
          },
          {
            key: "purchasing-invoices",
            path: urls.purchaseOrderInvoicesList,
            title: i18n.t("purchase_order_invoices"),
            icon: "",
            submenu: [],
          },
          {
            key: "purchasing-stock",
            path: urls.stockOverview,
            title: i18n.t("stock_overview"),
            icon: "",
            submenu: [],
          },
          {
            key: "purchasing-suppliers",
            path: urls.suppliersList,
            title: i18n.t("order.suppliers"),
            icon: "",
            submenu: [],
          },
          {
            key: "purchasing-product-drafts",
            path: urls.productDraftsList,
            title: i18n.t("product_drafts"),
            icon: "",
            submenu: [],
          },
        ],
      },
    ],
  },
];

const adminNavTree = [
  {
    isAdmin: true,
    key: "admin",
    title: i18n.t("admin"),
    breadcrumb: false,
    submenu: [
      {
        key: "admin-collections",
        path: urls.collections,
        title: i18n.t("collections"),
        icon: ApartmentOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "admin-groups",
        path: urls.groups,
        title: i18n.t("groups"),
        icon: GroupOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "admin-users",
        path: urls.users,
        title: i18n.t("users"),
        icon: UserOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "purchasing-documentation",
        path: urls.documentation,
        title: i18n.t("documentation"),
        icon: BookOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...shopNavTree, ...purchasingNavTree, ...adminNavTree];

export default navigationConfig;
